export const legalUiTranslations = Object.fromEntries(
  Object.entries({
    en: {
      "Terms of Service": "Terms of Service",
      LegalPage: { subtitle: "Legal Information & Notices" },
    },
    zh: {
      "Terms of Service": "服务条款",
      LegalPage: { subtitle: "法律信息与声明" },
    },
    "zh-TW": {
      "Terms of Service": "服務條款",
      LegalPage: { subtitle: "法律資訊與聲明" },
    },
    fr: {
      "Terms of Service": "Conditions d'utilisation",
      LegalPage: { subtitle: "Informations et avis juridiques" },
    },
    es: {
      "Terms of Service": "Términos del servicio",
      LegalPage: { subtitle: "Información y avisos legales" },
    },
    ar: {
      "Terms of Service": "شروط الخدمة",
      LegalPage: { subtitle: "المعلومات والإشعارات القانونية" },
    },
    ja: {
      "Terms of Service": "利用規約",
      LegalPage: { subtitle: "法的情報および告知" },
    },
    ru: {
      "Terms of Service": "Условия использования",
      LegalPage: { subtitle: "Юридическая информация и уведомления" },
    },
    ko: {
      "Terms of Service": "서비스 약관",
      LegalPage: { subtitle: "법률 정보 및 고지" },
    },
    pt: {
      "Terms of Service": "Termos de serviço",
      LegalPage: { subtitle: "Informações e avisos legais" },
    },
    "pt-BR": {
      "Terms of Service": "Termos de serviço",
      LegalPage: { subtitle: "Informações e avisos legais" },
    },
    it: {
      "Terms of Service": "Termini di servizio",
      LegalPage: { subtitle: "Informazioni e avvisi legali" },
    },
    de: {
      "Terms of Service": "Nutzungsbedingungen",
      LegalPage: { subtitle: "Rechtliche Informationen und Hinweise" },
    },
    hi: {
      "Terms of Service": "सेवा की शर्तें",
      LegalPage: { subtitle: "कानूनी जानकारी और सूचनाएँ" },
    },
    mn: {
      "Terms of Service": "Үйлчилгээний нөхцөл",
      LegalPage: { subtitle: "Хууль эрх зүйн мэдээлэл ба мэдэгдэл" },
    },
    th: {
      "Terms of Service": "ข้อกำหนดการให้บริการ",
      LegalPage: { subtitle: "ข้อมูลและประกาศทางกฎหมาย" },
    },
    uk: {
      "Terms of Service": "Умови користування",
      LegalPage: { subtitle: "Юридична інформація та повідомлення" },
    },
    vi: {
      "Terms of Service": "Điều khoản dịch vụ",
      LegalPage: { subtitle: "Thông tin và thông báo pháp lý" },
    },
    id: {
      "Terms of Service": "Ketentuan Layanan",
      LegalPage: { subtitle: "Informasi dan pemberitahuan hukum" },
    },
    tl: {
      "Terms of Service": "Mga Tuntunin ng Serbisyo",
      LegalPage: { subtitle: "Legal na Impormasyon at Mga Paunawa" },
    },
    bn: {
      "Terms of Service": "সেবার শর্তাবলী",
      LegalPage: { subtitle: "আইনি তথ্য ও নোটিশ" },
    },
  }).map(([locale, translation]) => [locale, translation]),
);
